
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteGroupRepositoryInterface, { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';
import { Website } from '@/services/Website/interfaces';
import { UserInterface, UserRepoInterface } from '@/services/Users/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
  ],
})
export default class ToggleGroupDialog extends Vue {
  @Prop() group!: WebsiteGroup;

  @Prop() mainWebsite!: Website;

  @Prop() public state!: string;

  public visible: boolean = true;

  public loading: boolean = true;

  public async created(): Promise<void> {
    this.loading = false
  }

  public async toggleGroup(): Promise<void> {
    this.$emit('toggleGroup');

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');

    this.visible = false;
    this.loading = true;
  }
}
